import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { StorySection } from '../components/StorySection';
import { ResultsSection } from '../components/ResultsSection';
import { BonusesSection } from '../components/BonusesSection';
import { ExpertSection } from '../components/ExpertSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { TestimonialCard } from '../components/TestimonialCard';
import { Section } from '../components/ui/Section';
import { SalesNotificationPopup } from '../components/SalesNotificationPopup';
export function LandingPage() {
  return <div className="min-h-screen font-sans" data-id="element-370">
      <HeroSection data-id="element-371" />
      <BenefitsSection data-id="element-372" />
      <StorySection data-id="element-373" />

      <Section background="gray" data-id="element-374">
        <div className="text-center mb-12" data-id="element-375">
          <h2 className="text-3xl font-serif font-bold text-gray-900 mb-4" data-id="element-376">
            Mujeres Reales. Resultados Reales.
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-377">
          <TestimonialCard quote="Por primera vez en años siento paz en casa." delay={0} data-id="element-378" />
          <TestimonialCard quote="Mi esposo dijo: '¿qué cambió aquí?' y lloré de emoción." delay={0.1} data-id="element-379" />
          <TestimonialCard quote="Recuperé mis fines de semana. Ya no soy esclava de la limpieza." delay={0.2} data-id="element-380" />
        </div>
      </Section>

      <ResultsSection data-id="element-381" />
      <ExpertSection data-id="element-382" />
      <BonusesSection data-id="element-383" />
      <PricingSection data-id="element-384" />
      <GuaranteeSection data-id="element-385" />
      <FAQSection data-id="element-386" />

      <section className="bg-[#2C7A7B] py-16 text-center px-4" data-id="element-387">
        <div className="max-w-2xl mx-auto" data-id="element-388">
          <h2 className="text-3xl font-serif font-bold text-white mb-6" data-id="element-389">
            Tu hogar no necesita más de ti. <br data-id="element-390" />
            Solo necesita el método correcto.
          </h2>
          <p className="text-[#D4AF37] font-medium mb-8 text-lg" data-id="element-391">
            Oferta navideña disponible por tiempo limitado.
          </p>
        </div>
      </section>

      <Footer data-id="element-392" />

      {/* Sales Notification Popup */}
      <SalesNotificationPopup data-id="element-393" />
    </div>;
}